(function () {
  'use strict';

  angular
    .module('doubleSectorInRollingSevenDays')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('doubleSectorInRollingSevenDays', {
        url: '/double-sector-in-rolling-seven-days',
        views: {
          'doubleSectorInRollingSevenDaysView': {
            templateUrl: 'double-sector-in-rolling-seven-days/views/double-sector-in-rolling-seven-days.tpl.html',
            controller: 'doubleSectorInRollingSevenDaysCtrl',
            controllerAs: 'doubleSectorInRollingSevenDays'
          }
        }
      });
  }
}());
